import { render, staticRenderFns } from "./EditVdoSet.vue?vue&type=template&id=0895d4ce&scoped=true&"
import script from "./EditVdoSet.vue?vue&type=script&lang=js&"
export * from "./EditVdoSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0895d4ce",
  null
  
)

export default component.exports